module.exports = __webpack_public_path__ + "img/autonomous-systems.c27f2985.jpg";